import React, { useEffect } from "react";
import "../App.css";
import GalleryLightbox from "../components/GalleryLightbox";

const LandingPage: React.FC = () => {

  
  return (
    
    <main className="main">

    {/* <!-- Hero Section --> */}
    <section id="hero" className="hero section dark-background">

      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-4 order-lg-last hero-img" data-aos="zoom-out">
            <img src="templates/softland/assets/img/phone_3.png" alt="Phone 1" className="phone-1" />
            <img src="templates/softland/assets/img/phone_4.png" alt="Phone 2" className="phone-2" />
          </div>
          <div className="col-lg-8 d-flex flex-column justify-content-center align-items text-center text-md-start" data-aos="fade-up">
                         <h2>ScanNChat - Your Time is Precious</h2>
             <p>Why waste time sending emails or messages just to share a simple text or link between your devices?</p>
            <div className="d-flex mt-4 justify-content-center justify-content-md-start">
              <a href="https://play.google.com/store/apps/details?id=com.copyandpaste.copyandpaste&pcampaignid=web_share" className="download-btn"><i className="bi bi-google-play"></i> <span>Google Play</span></a>
              <a href="#" className="download-btn"><i className="bi bi-apple"></i> <span>App Store</span></a>
            </div>
          </div>
        </div>
      </div>

    </section>{/* <!-- /Hero Section --> */}

    {/* <!-- About Section --> */}
    <section id="about" className="about section">

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-xl-center gy-5">

                     <div className="col-xl-5 content">
             <h3>About ScanNChat</h3>
             <h2>Sync messages across multiple devices seamlessly</h2>
             <p>This app allows you to sync messages across multiple devices seamlessly. It is designed to be simple and easy to use. You can also create an ephemeral discussion with other users without sharing your personal informations.</p>
             <a href="#" className="read-more"><span>Read More</span><i className="bi bi-arrow-right"></i></a>
          </div>

          <div className="col-xl-7">
            <div className="row gy-4 icon-boxes">

                             <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                 <div className="icon-box">
                   <i className="bi bi-laptop"></i>
                   <h3>Universal Synchronization</h3>
                   <p>Copy a message, text, or link on your phone and paste it on your desktop, and vice versa</p>
                 </div>
               </div> {/* <!-- End Icon Box --> */}

               <div className="col-md-6" data-aos="fade-up" data-aos-delay="300">
                 <div className="icon-box">
                   <i className="bi bi-clock"></i>
                   <h3>Ephemeral Messages</h3>
                   <p>Your messages disappear after a defined time. No trace if you don't want it</p>
                 </div>
               </div> {/* <!-- End Icon Box --> */}

               <div className="col-md-6" data-aos="fade-up" data-aos-delay="400">
                 <div className="icon-box">
                   <i className="bi bi-phone"></i>
                   <h3>QR Code Scanner</h3>
                   <p>Quick and secure connection via QR code between different devices</p>
                 </div>
               </div> {/* <!-- End Icon Box --> */}

               <div className="col-md-6" data-aos="fade-up" data-aos-delay="500">
                 <div className="icon-box">
                   <i className="bi bi-lock"></i>
                   <h3>Secure & Private</h3>
                   <p>Chat with strangers without sharing personal information</p>
                 </div>
               </div> {/* <!-- End Icon Box --> */}

            </div>
          </div>

        </div>
      </div>

    </section>{/* <!-- /About Section --> */}

    {/* <!-- Featured Section --> */}
    <section id="" className="featured section">

             {/* <!-- Section Title --> */}
       <div className="container section-title" data-aos="fade-up">
         <h2>One Application. All Your Devices.</h2>
         <p>Copy on phone → paste on PC, instantly and securely</p>
       </div>{/* <!-- End Section Title --> */}

      <div className="container">

        <div className="row gy-4" data-aos="fade-up" data-aos-delay="100">

                     <div className="col-md-4">
             <div className="card">
               <div className="img">
                 <img src="templates/softland/assets/img/cards-2.png" alt="" className="img-fluid" />
                 <div className="icon"><i className="bi bi-hdd-stack"></i></div>
               </div>
               <h2 className="title">Quick Transfers</h2>
               <p>
                 Copy a URL on your phone → paste it immediately on your computer without email or cloud storage. Instant synchronization via Firebase Realtime Database.
               </p>
             </div>
           </div>{/* <!-- End Card Item --> */}

           <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
             <div className="card">
               <div className="img">
                 <img src="templates/softland/assets/img/cards-6.png" alt="" className="img-fluid" />
                 <div className="icon"><i className="bi bi-brightness-high"></i></div>
               </div>
               <h2 className="title">Sensitive Information</h2>
               <p>
                 Exchange sensitive information that auto-deletes after a set time for enhanced security. Perfect for temporary discussions without sharing personal details.
               </p>
             </div>
           </div>{/* <!-- End Card Item --> */}

           <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
             <div className="card">
               <div className="img">
                 <img src="templates/softland/assets/img/cards-4.png" alt="" className="img-fluid" />
                 <div className="icon"><i className="bi bi-calendar4-week"></i></div>
               </div>
               <h2 className="title">Anonymous Chat</h2>
               <p>
                 Chat with strangers without sharing personal information. Create ephemeral discussions that last 7 days and then disappear automatically.
               </p>
             </div>
           </div>{/* <!-- End Card Item --> */}

        </div>

      </div>

    </section>{/* <!-- /Featured Section --> */}

    {/* <!-- Cards Section --> */}
    <section id="cards" className="cards section">

      <div className="container">

        {/* <div className="text-center mb-4 steps-img" data-aos="zoom-out">
          <img src="templates/softland/assets/img/steps.svg" alt="" />
        </div> */}

        <div className="row gy-4">

                     <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
             <div className="card-item">
               <span>01</span>
               <h4>Copy on Phone</h4>
               <p>Copy any text, link, or message on your mobile device. The content is instantly synchronized to your account</p>
             </div>
           </div>{/* <!-- Card Item --> */}

           <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
             <div className="card-item">
               <span>02</span>
               <h4><a href="" className="stretched-link">Instant Sync</a></h4>
               <p>Real-time synchronization via Firebase Realtime Database ensures your content is available across all devices</p>
             </div>
           </div>{/* <!-- Card Item --> */}

           <div className="col-lg-4" data-aos="fade-up" data-aos-delay="300">
             <div className="card-item">
               <span>03</span>
               <h4><a href="" className="stretched-link">Paste on PC</a></h4>
               <p>Access your copied content instantly on desktop or web. No email, no cloud storage needed</p>
             </div>
           </div>{/* <!-- Card Item --> */}

        </div>

      </div>

    </section>{/* <!-- /Cards Section --> */}

    {/* <!-- Features Section --> */}
    <section id="features" className="features section">

             {/* <!-- Section Title --> */}
       <div className="container section-title" data-aos="fade-up">
         <h2>Key Features</h2>
         <p>Simple, fast, and secure - everything you need for seamless device synchronization</p>
       </div>{/* <!-- End Section Title --> */}

      <div className="container">

        <div className="row gy-4 align-items-center features-item">
          <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="100">
            <img src="templates/softland/assets/img/features-5.svg" className="img-fluid" alt="" />
          </div>
                     <div className="col-md-7" data-aos="fade-up" data-aos-delay="100">
             <h3>Universal Synchronization Across All Your Devices</h3>
             <p className="fst-italic">
               Copy a message, text, or link on your phone and paste it on your desktop, and vice versa. 
               Instant synchronization via Firebase Realtime Database.
             </p>
             <ul>
               <li><i className="bi bi-check"></i><span> Real-time sync between mobile, desktop, and web</span></li>
               <li><i className="bi bi-check"></i> <span>No email or cloud storage required</span></li>
               <li><i className="bi bi-check"></i> <span>Secure and encrypted data transmission</span></li>
             </ul>
           </div>
        </div>{/* <!-- Features Item --> */}

        <div className="row gy-4 align-items-center features-item">
          <div className="col-md-5 order-1 order-md-2 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="200">
            <img src="templates/softland/assets/img/features-10.svg" className="img-fluid" alt="" />
          </div>
                     <div className="col-md-7 order-2 order-md-1" data-aos="fade-up" data-aos-delay="200">
             <h3>Ephemeral Messages for Enhanced Privacy</h3>
             <p className="fst-italic">
               Your messages disappear after a defined time. No trace if you don't want it.
             </p>
             <p>
               Create temporary discussions that last 7 days and then disappear automatically. Perfect for sharing sensitive information or having anonymous conversations without leaving any digital footprint.
             </p>
           </div>
        </div>{/* <!-- Features Item --> */}

        <div className="row gy-0 align-items-center features-item">
          <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out">
            <img src="templates/softland/assets/img/features-7.svg" className="img-fluid" alt="" />
          </div>
                     <div className="col-md-7" data-aos="fade-up">
             <h3>QR Code Scanner for Quick Device Connection</h3>
             <p>Quick and secure connection via QR code between different devices. Easily associate a new device to your account without complex setup procedures.</p>
             <ul>
               <li><i className="bi bi-check"></i> <span>Instant device pairing with QR code scan</span></li>
               <li><i className="bi bi-check"></i><span> Secure authentication without sharing credentials</span></li>
               <li><i className="bi bi-check"></i> <span>Works across mobile, desktop, and web platforms</span></li>
             </ul>
           </div>
        </div>{/* <!-- Features Item --> */}

        <div className="row gy-4 align-items-center features-item">
          <div className="col-md-5 order-1 order-md-2 d-flex align-items-center" data-aos="zoom-out">
            <img src="templates/softland/assets/img/features-8.svg" className="img-fluid" alt="" />
          </div>
                     <div className="col-md-7 order-2 order-md-1" data-aos="fade-up">
             <h3>Customizable Interface with Light and Dark Themes</h3>
             <p className="fst-italic">
               Choose between light and dark themes. Clean, fast, and responsive interface designed for the best user experience.
             </p>
             <p>
               Our interface adapts to your preferences with customizable themes. The responsive design ensures optimal experience across all devices, from mobile phones to desktop computers.
             </p>
           </div>
        </div>{/* <!-- Features Item --> */}

      </div>

    </section>{/* <!-- /Features Section --> */}

    {/* <!-- Gallery Section --> */}
    <section id="gallery" className="gallery section">

             {/* <!-- Section Title --> */}
       <div className="container section-title" data-aos="fade-up">
         <h2>See ScanNChat in Action</h2>
         <p>Explore our app screenshots and see how easy it is to sync across devices</p>
       </div>{/* <!-- End Section Title --> */}

      <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">

        <GalleryLightbox />

      </div>

    </section>{/* <!-- /Gallery Section --> */}

    

    {/* <!-- Pricing Section --> */}
    <section id="pricing" className="pricing section">

             {/* <!-- Section Title --> */}
       <div className="container section-title" data-aos="fade-up">
         <h2>Free... and Even Better!</h2>
         <p>Enjoy the essentials for free or unlock longer durations with our premium offers</p>
       </div>{/* <!-- End Section Title --> */}

      <div className="container" data-aos="zoom-in" data-aos-delay="100">

        <div className="row g-4">

                     <div className="col-lg-4">
             <div className="pricing-item">
               <h3>Free Plan</h3>
               <div className="icon">
                 <i className="bi bi-box"></i>
               </div>
               <h4><sup>$</sup>0<span> / month</span></h4>
               <ul>
                 <li><i className="bi bi-check"></i> <span>7 days discussions duration</span></li>
                 <li><i className="bi bi-check"></i> <span>Basic synchronization</span></li>
                 <li><i className="bi bi-check"></i> <span>QR code connection</span></li>
                 <li className="na"><i className="bi bi-x"></i> <span>Extended discussion time</span></li>
                 <li className="na"><i className="bi bi-x"></i> <span>Priority support</span></li>
               </ul>
               <div className="text-center"><a href="#" className="buy-btn">Get Started</a></div>
             </div>
           </div>{/* <!-- End Pricing Item --> */}

                     <div className="col-lg-4">
             <div className="pricing-item featured">
               <h3>Premium Plan</h3>
               <div className="icon">
                 <i className="bi bi-rocket"></i>
               </div>

               <h4><sup>$</sup>4.99<span> / month</span></h4>
               <ul>
                 <li><i className="bi bi-check"></i> <span>All free features included</span></li>
                 <li><i className="bi bi-check"></i> <span>Unlimited discussions extensions time</span></li>
                 <li><i className="bi bi-check"></i> <span>Advanced synchronization</span></li>
                 <li><i className="bi bi-check"></i> <span>Priority support</span></li>
               </ul>
               <div className="text-center"><a href="#" className="buy-btn">Subscribe Now</a></div>
             </div>
           </div>{/* <!-- End Pricing Item --> */}

                     <div className="col-lg-4">
             <div className="pricing-item">
               <h3>Pay-Per-Use</h3>
               <div className="icon">
                 <i className="bi bi-send"></i>
               </div>
               <h4><sup>$</sup>0.99<span> / 7 days</span></h4>
               <ul>
                 <li><i className="bi bi-check"></i> <span>Extend single discussion</span></li>
                 <li><i className="bi bi-check"></i> <span>7 days or 30 days option</span></li>
                 <li><i className="bi bi-check"></i> <span>One-time payment</span></li>
                 <li><i className="bi bi-check"></i> <span>Apple Pay & Google Pay</span></li>
                 <li><i className="bi bi-check"></i> <span>No subscription required</span></li>
               </ul>
               <div className="text-center"><a href="#" className="buy-btn">Extend Now</a></div>
             </div>
           </div>{/* <!-- End Pricing Item --> */}

        </div>

      </div>

    </section>{/* <!-- /Pricing Section --> */}

    {/* <!-- Faq Section --> */}
    <section id="faq" className="faq section">

             {/* <!-- Section Title --> */}
       <div className="container section-title" data-aos="fade-up">
         <h2>Frequently Asked Questions</h2>
         <p>Everything you need to know about ScanNChat</p>
       </div>{/* <!-- End Section Title --> */}

      <div className="container">

        <div className="row justify-content-center">

          <div className="col-lg-10" data-aos="fade-up" data-aos-delay="100">

            <div className="faq-container">

                             <div className="faq-item faq-active">
                 <h3>What is ScanNChat about?</h3>
                 <div className="faq-content">
                   <p>This app allows you to sync your own private messages across multiple devices. You can also create an ephemeral discussion with other users without sharing your personal information. These chats last 7 days and then disappear.</p>
                 </div>
                 <i className="faq-toggle bi bi-chevron-right"></i>
               </div>{/* <!-- End Faq item--> */}

                             <div className="faq-item">
                 <h3>How do I create a new private message?</h3>
                 <div className="faq-content">
                   <p>To create a new private message, click on the 'Today' button in the 'Private messages' section. Then you can add a new message for this date.</p>
                 </div>
                 <i className="faq-toggle bi bi-chevron-right"></i>
               </div>{/* <!-- End Faq item--> */}

                             <div className="faq-item">
                 <h3>How do I launch a new discussion?</h3>
                 <div className="faq-content">
                   <p>To launch a new discussion, click on the 'New' button in the 'Discussions' section. Then you can share this discussion link, QR Code or ID to invite another user to discuss with you.</p>
                 </div>
                 <i className="faq-toggle bi bi-chevron-right"></i>
               </div>{/* <!-- End Faq item--> */}

                             <div className="faq-item">
                 <h3>How does the subscription system work?</h3>
                 <div className="faq-content">
                   <p>Monthly subscribers ($4.99/month) can extend any discussion for 7 or 30 days. Non-subscribers can pay $0.99 for 7 days or $2.99 for 30 days per discussion. Only one user needs to pay for the entire discussion.</p>
                 </div>
                 <i className="faq-toggle bi bi-chevron-right"></i>
               </div>{/* <!-- End Faq item--> */}

                             <div className="faq-item">
                 <h3>How do I make a donation?</h3>
                 <div className="faq-content">
                   <p>You can make a donation through the app to support our development. Your donations help us to maintain and improve the app. Any amount is greatly appreciated!</p>
                 </div>
                 <i className="faq-toggle bi bi-chevron-right"></i>
               </div>{/* <!-- End Faq item--> */}

                             <div className="faq-item">
                 <h3>What platforms are supported?</h3>
                 <div className="faq-content">
                   <p>ScanNChat is available on Mobile (Flutter for Android & iOS), Desktop (Electron for Windows, macOS, Linux), and Web. All platforms sync seamlessly in real-time.</p>
                 </div>
                 <i className="faq-toggle bi bi-chevron-right"></i>
               </div>{/* <!-- End Faq item--> */}

            </div>

          </div>{/* <!-- End Faq Column--> */}

        </div>

      </div>

    </section>{/* <!-- /Faq Section --> */}

    {/* <!-- Contact Section --> */}
    <section id="contact" className="contact section">

             
       <div className="container section-title" data-aos="fade-up">
         <h2>Support & Contact</h2>
         <p>Get in touch with our support team for any questions or assistance</p>
       </div>

      <div className="container" data-aos="fade" data-aos-delay="100">

        <div className="row gy-4">

          <div className="col-lg-4 ">
              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
               <i className="bi bi-geo-alt flex-shrink-0"></i>
               <div>
                 <h3>Address</h3>
                 <p>Copy&Paste LLC Company</p>
               </div>
             </div>
          </div>
          <div className="col-lg-4 ">
              
             <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
               <i className="bi bi-telephone flex-shrink-0"></i>
               <div>
                 <h3>Call Us</h3>
                 <p>845-536-7973</p>
               </div>
             </div>
          </div>
          <div className="col-lg-4 ">

             <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
               <i className="bi bi-envelope flex-shrink-0"></i>
               <div>
                 <h3>Email Us</h3>
                 <p>customer-service@scannchat.com</p>
               </div>
             </div>

          </div>
          {/* <div className="col-lg-4 ">
                         <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
               <i className="bi bi-geo-alt flex-shrink-0"></i>
               <div>
                 <h3>Address</h3>
                 <p>Copy&Paste LLC Company, Global</p>
               </div>
             </div>

             <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
               <i className="bi bi-telephone flex-shrink-0"></i>
               <div>
                 <h3>Call Us</h3>
                 <p>845-536-7973</p>
               </div>
             </div>

             <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
               <i className="bi bi-envelope flex-shrink-0"></i>
               <div>
                 <h3>Email Us</h3>
                 <p>customer-service@scannchat.com</p>
               </div>
             </div>

          </div> */}

          {/* <div className="col-lg-8">
            <form action="forms/contact.php" method="post" className="php-email-form" data-aos="fade-up" data-aos-delay="200">
              <div className="row gy-4">

                <div className="col-md-6">
                  <input type="text" name="name" className="form-control" placeholder="Your Name" />
                </div>

                <div className="col-md-6 ">
                  <input type="email" className="form-control" name="email" placeholder="Your Email" />
                </div>

                <div className="col-md-12">
                  <input type="text" className="form-control" name="subject" placeholder="Subject" />
                </div>

                <div className="col-md-12">
                  <textarea className="form-control" name="message"  placeholder="Message" ></textarea>
                </div>

                <div className="col-md-12 text-center">
                  <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">Your message has been sent. Thank you!</div>

                  <button type="submit">Send Message</button>
                </div>

              </div>
            </form>
          </div> */}

        </div>

      </div>

    </section>
     {/* <!-- /Contact Section --> */}

  </main>

  );
};

export default LandingPage;
